type Text4Prop = {
  text : string
}

const Text4 = ({text} : Text4Prop) => {
    return (
      <span className="text-text4">{text}</span>
    )
  }
  
  export default Text4